import { rotuloRevisar } from './formato'

/**
 * Lo marcado, contado, y el paso a la revision.
 *
 * El rotulo del boton dice **cuantos clientes y que dia**, como el de publicar y
 * por lo mismo: es lo ultimo que se mira antes de pulsar, y treinta casillas
 * marcadas no se recuentan a ojo.
 *
 * Los marcados a los que todavia les falta el bono se cuentan aparte en vez de
 * bloquear el boton: se puede seguir, y la revision dira fila por fila cual no
 * tiene linea de pedido. Bloquear aqui obligaria a elegirle el bono a treinta
 * clientes antes de descubrir que a uno le falta la ficha de Odoo.
 */

interface Props {
  marcados: number
  sinBono: number
  fecha: string
  revisando: boolean
  onRevisar: () => void
  onSoltar: () => void
}

export function BarraSeleccion({
  marcados,
  sinBono,
  fecha,
  revisando,
  onRevisar,
  onSoltar,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-borde bg-superficie px-4 py-3">
      <button
        type="button"
        disabled={marcados === 0 || revisando}
        onClick={onRevisar}
        className="rounded-lg border border-acento-borde bg-acento-suave px-4 py-2 text-sm font-semibold text-acento-tinta transition-colors hover:bg-acento-tinta-suave disabled:cursor-not-allowed disabled:border-borde disabled:bg-desactivado disabled:text-desactivado-tinta"
      >
        {revisando ? 'Componiendo los pedidos' : rotuloRevisar(marcados, fecha)}
      </button>

      <p className="text-sm text-tinta-apagada">
        {marcados === 0
          ? 'Marca los clientes que entran en el reparto.'
          : `${marcados === 1 ? '1 cliente marcado' : `${marcados} clientes marcados`}${
              sinBono > 0
                ? `, ${sinBono === 1 ? '1 sin bono elegido' : `${sinBono} sin bono elegido`}`
                : ''
            }.`}
      </p>

      {marcados > 0 ? (
        <button
          type="button"
          onClick={onSoltar}
          className="ml-auto rounded-lg border border-borde-fuerte bg-superficie px-3 py-2 text-sm font-medium text-tinta-2 transition-colors hover:bg-elevado"
        >
          Soltar los marcados
        </button>
      ) : null}
    </div>
  )
}
